<template>
  <b-row>
    <b-col cols="12">
        <b-form-group>
          <label for="title">{{ $t('global.title') }}</label>
          <input type="text" id="title" class="form-control" v-model="variant.title" :placeholder="$t('global.title')">
        </b-form-group>
    </b-col>
    <b-col cols="12">
      <hr class="my-1">
      <span class="h6 float-left">{{$t("views.agreements.form.items")}}: </span>
    </b-col>
    <b-col cols="12">
      <table v-if="variant.variantItems && variant.variantItems.length > 0"
             class="table table-responsive-md table-sm table-hover not-border-table">
        <thead class="text-center">
        <tr>
          <th style="width: 4%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.lp')}}</p>
          </th>
          <th style="width: 3%">
            <i class="fa fa-clock fa-lg" v-b-tooltip :title="$t('buttons.cyclicItem')"></i>
          </th>
          <th style="width: 3%">
            <i class="fa fa-percentage fa-lg" v-b-tooltip :title="$t('buttons.promotion')"></i>
          </th>
          <th style="width: 20%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.item')}}</p>
          </th>
          <th style="width: 20%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.valueNetto')}}</p>
          </th>
          <th style="width: 10%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.vatRate')}}</p>
          </th>
          <th style="width: 10%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.vatAmount')}}</p>
          </th>
          <th style="width: 20%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.valueBrutto')}}</p>
          </th>
          <th style="width: 10%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.promotionDifference')}}</p>
          </th>
          <th style="width: 5%"></th>
        </tr>
        </thead>
        <tbody v-for="(item, index) in variant.variantItems" :key="index">
        <tr v-if="items && items.length > 0">
          <td><span class="h6"> {{ index + 1 }} </span></td>
          <!--    TOWAR-->
          <td>
            <b-form-checkbox
                :id="`checkbox-variant-${variantIndex}-${index}`"
                v-model="item.isCyclic"
                :name="`checkbox-variant-${variantIndex}-${index}`"
                :value="1"
                :unchecked-value="0"
                :disabled="!item.canBeCyclic || !item.item"
            >
            </b-form-checkbox>
          </td>
          <td>
            <b-form-checkbox
                :id="`checkboxpromotion-variant-${variantIndex}-${index}`"
                v-model="item.hasPromotion"
                :name="`checkboxpromotion-variant-${variantIndex}-${index}`"
                :value="true"
                :unchecked-value="false"
                :disabled="hasItemCustomPrices(item)"
            >
            </b-form-checkbox>
          </td>
          <td>
            <model-select v-if="variant.variantItems.length > 0"
                          v-model="variant.variantItems[index].item"
                          :options="itemOptions"
                          :placeholder="$t('views.agreements.form.select')"
                          name="item">
            </model-select>
          </td>
          <!--    WARTOŚĆ NETTO-->
          <td class="pt-0 pb-0">
            <input type="number" disabled="true" :value="getPriceNetto(index)" class="form-control">
          </td>
          <!--    STAWKA VAT-->
          <td>
            <input type="text" disabled="true" :value="getVatRate(index)" class="form-control">
          </td>
          <!--    WARTOŚĆ VAT-->
          <td>
            <input type="number" disabled="true" :value="getVatValue(index)" class="form-control">
          </td>
          <!--    WARTOŚĆ BRUTTO-->
          <td v-if="hasItemCustomPrices(index)">
            <model-select :options="priceOptions[index]"
                          v-model="variant.variantItems[index].priceUserData"></model-select>
          </td>
          <td v-else>
            <input type="number" disabled="true" :value="getPriceBrutto(index)" class="form-control">
          </td>
          <td>
            <input v-if="item.item" type="number" disabled="true" :value="(getPriceBrutto(index) - getItemById(getCurrentItem(index).item).priceBrutto).toFixed(2)" class="form-control">
          </td>
          <td>
            <button
                type="button"
                class="btn btn-link fa fa-trash fa-lg"
                @click="removePosition(index)"
                v-b-tooltip :title="$t('buttons.delete')">
            </button>
          </td>
        </tr>
        <tr v-if="item.isCyclic">
          <td colspan="3"></td>
          <td>
            <b>{{$t('buttons.cyclicItem')}}</b>
          </td>
          <td colspan="5">
            <b-row>
              <b-col cols="1" align-self="center">
                  <span class="mr-3">
                    <b>{{$t('global.from')}}:</b>
                  </span>
              </b-col>
              <b-col>
                <b-form-group>
                  <el-date-picker
                      :picker-options="{firstDayOfWeek: 1}"
                      class="d-inline-block"
                      id="date_from"
                      v-model="variant.variantItems[index].dateFrom"
                      type="date"
                      value-format="yyyy-MM-dd"
                      format="yyyy-MM-dd">
                  </el-date-picker>
                </b-form-group>
              </b-col>
              <b-col v-if="!item.timeless" cols="1" align-self="center">
                  <span class="mr-3">
                    <b>{{$t('global.to')}}:</b>
                  </span>
              </b-col>
              <b-col v-if="!item.timeless">
                <b-form-group>
                  <el-date-picker
                      :picker-options="{firstDayOfWeek: 1}"
                      class="d-inline-block"
                      id="date_to"
                      v-model="variant.variantItems[index].dateTo"
                      type="date"
                      value-format="yyyy-MM-dd"
                      format="yyyy-MM-dd">
                  </el-date-picker>
                </b-form-group>
              </b-col>
              <b-col align-self="center">
                <b-form-group>
                  <b-form-checkbox
                      v-model="variant.variantItems[index].timeless"
                      :name="`timeless_variant_${variantIndex}-${index}`"
                      :value="true"
                      :unchecked-value="false"
                      @input="setTimelessItem(index)">
                    <span>
                      {{$t('views.agreements.form.timelessCyclicItem')}}
                    </span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col align-self="center">
                <b-form-group>
                  <b-form-checkbox
                      v-model="variant.variantItems[index].alwaysSettleInFull"
                      :name="`alwaysSettleInFull_variant_${variantIndex}-${index}`"
                      :value="1"
                      :unchecked-value="0">
                    <span>
                      {{$t('views.agreements.form.alwaysSettleInFull')}}
                    </span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
          </td>
        </tr>
        <tr v-if="item.hasPromotion">
          <td colspan="3"></td>
          <td>
            <b>{{$t('buttons.promotion')}}</b>
          </td>
          <td>
            <b v-if="item.item">{{$t('views.agreements.form.basePriceWithoutPromotion')}}: {{ getItemById(getCurrentItem(index).item).priceBrutto }}</b>
          </td>
          <td colspan="4">
            <model-select v-if="getPromotions.length > 0"
                          v-model="variant.variantItems[index].promotion"
                          :options="getPromotions"
                          :placeholder="$t('views.agreements.form.select')"
                          name="promotion">
            </model-select>
          </td>
        </tr>
        </tbody>
      </table>
    </b-col>
    <b-col cols="12">
      <b-row>
        <b-col>
          <b-button class="btn float-left btn-primary" @click="addNewItemPosition()">{{ $t('views.exsbinvoices.form.addNewInvoicePosition') }}</b-button>
        </b-col>
      </b-row>
      <b-col cols="12">
        <hr class="my-1">
        <span class="h6 float-left">{{$t("views.agreements.form.additionalItems")}}: </span>
      </b-col>
    </b-col>
    <b-col cols="12">
      <table v-if="variant.variantAdditionalItems && variant.variantAdditionalItems.length > 0"
             class="table table-responsive-md table-sm table-hover not-border-table">
        <thead class="text-center">
        <tr>
          <th style="width: 4%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.lp')}}</p>
          </th>
          <th style="width: 3%">
            <i class="fa fa-clock fa-lg" v-b-tooltip :title="$t('buttons.cyclicItem')"></i>
          </th>
          <th style="width: 3%">
            <i class="fa fa-percentage fa-lg" v-b-tooltip :title="$t('buttons.promotion')"></i>
          </th>
          <th style="width: 20%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.item')}}</p>
          </th>
          <th style="width: 20%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.valueNetto')}}</p>
          </th>
          <th style="width: 10%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.vatRate')}}</p>
          </th>
          <th style="width: 10%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.vatAmount')}}</p>
          </th>
          <th style="width: 20%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.valueBrutto')}}</p>
          </th>
          <th style="width: 10%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.promotionDifference')}}</p>
          </th>
          <th style="width: 5%"></th>
        </tr>
        </thead>
        <tbody v-for="(item, index) in variant.variantAdditionalItems" :key="index">
        <tr v-if="items && items.length > 0">
          <td><span class="h6"> {{ index + 1 }} </span></td>
          <!--    TOWAR-->
          <td>
            <b-form-checkbox
              :id="`checkbox-variant-additional-${variantIndex}-${index}`"
              v-model="item.isCyclic"
              :name="`checkbox-variant-additional-${variantIndex}-${index}`"
              :value="1"
              :unchecked-value="0"
              :disabled="!item.canBeCyclic || !item.item"
            >
            </b-form-checkbox>
          </td>
          <td>
            <b-form-checkbox
              :id="`checkboxpromotion-variant-additional-${variantIndex}-${index}`"
              v-model="item.hasPromotion"
              :name="`checkboxpromotion-variant-additional-${variantIndex}-${index}`"
              :value="true"
              :unchecked-value="false"
              :disabled="hasAdditionalItemCustomPrices(item)"
            >
            </b-form-checkbox>
          </td>
          <td>
            <model-select v-if="variant.variantAdditionalItems.length > 0"
                          v-model="variant.variantAdditionalItems[index].item"
                          :options="itemOptions"
                          :placeholder="$t('views.agreements.form.select')"
                          name="item">
            </model-select>
          </td>
          <!--    WARTOŚĆ NETTO-->
          <td class="pt-0 pb-0">
            <input type="number" disabled="true" :value="getPriceNettoAdditional(index)" class="form-control">
          </td>
          <!--    STAWKA VAT-->
          <td>
            <input type="text" disabled="true" :value="getVatRateAdditional(index)" class="form-control">
          </td>
          <!--    WARTOŚĆ VAT-->
          <td>
            <input type="number" disabled="true" :value="getVatValueAdditional(index)" class="form-control">
          </td>
          <!--    WARTOŚĆ BRUTTO-->
          <td v-if="hasAdditionalItemCustomPrices(index)">
            <model-select :options="priceOptions[index]"
                          v-model="variant.variantAdditionalItems[index].priceUserData"></model-select>
          </td>
          <td v-else>
            <input type="number" disabled="true" :value="getPriceBruttoAdditional(index)" class="form-control">
          </td>
          <td>
            <input v-if="item.item" type="number" disabled="true" :value="(getPriceBruttoAdditional(index) - getItemById(getCurrentAdditionalItem(index).item).priceBrutto).toFixed(2)" class="form-control">
          </td>
          <td>
            <button
              type="button"
              class="btn btn-link fa fa-trash fa-lg"
              @click="removeAdditionalPosition(index)"
              v-b-tooltip :title="$t('buttons.delete')">
            </button>
          </td>
        </tr>
        <tr v-if="item.isCyclic">
          <td colspan="3"></td>
          <td>
            <b>{{$t('buttons.cyclicItem')}}</b>
          </td>
          <td colspan="5">
            <b-row>
              <b-col cols="1" align-self="center">
                <span class="mr-3">
                  <b>{{$t('global.from')}}:</b>
                </span>
              </b-col>
              <b-col>
                <b-form-group>
                  <el-date-picker
                    :picker-options="{firstDayOfWeek: 1}"
                    class="d-inline-block"
                    id="date_from"
                    v-model="variant.variantAdditionalItems[index].dateFrom"
                    type="date"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd">
                  </el-date-picker>
                </b-form-group>
              </b-col>
              <b-col v-if="!item.timeless" cols="1" align-self="center">
                <span class="mr-3">
                  <b>{{$t('global.to')}}:</b>
                </span>
              </b-col>
              <b-col v-if="!item.timeless">
                <b-form-group>
                  <el-date-picker
                    :picker-options="{firstDayOfWeek: 1}"
                    class="d-inline-block"
                    id="date_to"
                    v-model="variant.variantAdditionalItems[index].dateTo"
                    type="date"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd">
                  </el-date-picker>
                </b-form-group>
              </b-col>
              <b-col align-self="center">
                <b-form-group>
                  <b-form-checkbox
                    v-model="variant.variantAdditionalItems[index].timeless"
                    :name="`timeless_variant_additional_${variantIndex}-${index}`"
                    :value="true"
                    :unchecked-value="false"
                    @input="setTimelessAdditionalItem(index)">
                  <span>
                    {{$t('views.agreements.form.timelessCyclicItem')}}
                  </span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col align-self="center">
                <b-form-group>
                  <b-form-checkbox
                    v-model="variant.variantAdditionalItems[index].alwaysSettleInFull"
                    :name="`alwaysSettleInFull_variant_additional_${variantIndex}-${index}`"
                    :value="1"
                    :unchecked-value="0">
                  <span>
                    {{$t('views.agreements.form.alwaysSettleInFull')}}
                  </span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
          </td>
        </tr>
        <tr v-if="item.hasPromotion">
          <td colspan="3"></td>
          <td>
            <b>{{$t('buttons.promotion')}}</b>
          </td>
          <td>
            <b v-if="item.item">{{$t('views.agreements.form.basePriceWithoutPromotion')}}: {{ getItemById(getCurrentAdditionalItem(index).item).priceBrutto }}</b>
          </td>
          <td colspan="4">
            <model-select v-if="getPromotions.length > 0"
                          v-model="variant.variantAdditionalItems[index].promotion"
                          :options="getPromotions"
                          :placeholder="$t('views.agreements.form.select')"
                          name="promotion">
            </model-select>
          </td>
        </tr>
        </tbody>
      </table>
    </b-col>
    <b-col cols="12">
      <b-button class="btn float-left btn-primary" @click="addNewAdditionalItemPosition()">{{ $t('views.exsbinvoices.form.addNewInvoicePosition') }}</b-button>
    </b-col>
  </b-row>
</template>
<script>
import remove from '@/utils/remove'
import { ModelSelect } from 'vue-search-select'

export default {
  name: 'AgreementVariants',
  props: ['data', 'variant', 'variantIndex', 'items', 'itemOptions', 'priceOptions', 'getPromotions'],
  components: {
    ModelSelect
  },
  methods: {
    getItemById (id) {
      return this.items.find(item => item['@id'] === id)
    },
    setTimelessItem (index) {
      if (this.getCurrentItem(index).timeless) this.getCurrentItem(index).dateTo = null
    },
    hasItemCustomPrices (index) {
      if (!this.priceOptions[index]) return false
      return this.priceOptions[index].length > 1
    },
    removePosition (index) {
      let currentItem = this.variant.variantItems[index]
      if (currentItem && currentItem['@id']) {
        remove(currentItem['@id'], () => {
          this.variant.variantItems.splice(index, 1)
        })
      } else {
        this.variant.variantItems.splice(index, 1)
      }
    },
    getPriceNetto (index) {
      return Math.round((this.getPriceBrutto(index) - this.getVatValue(index)) * 100) / 100
    },
    getPriceBrutto (index) {
      if (!this.getCurrentItem(index).item || this.items.length < 1) return 0
      let isCustomPriceSelected = (this.getCurrentItem(index).priceUserData && typeof this.getCurrentItem(index).priceUserData === 'string')
      if (isCustomPriceSelected) {
        return this.priceUserDataObjects.find(entry => {
          return entry.idItem['@id'] === this.getCurrentItem(index).item
        }).priceBrutto
      }
      let promotionId = (this.getCurrentItem(index).promotion)
      if (promotionId && this.getPromotions.length > 1) {
        let promotion = this.getPromotions.find(promotion => promotion.value === promotionId)
        let basePriceBrutto = this.getItemById(this.getCurrentItem(index).item).priceBrutto
        if (promotion.type === 0) { // Promocja kwotowa
          return (basePriceBrutto - promotion.promotionValue).toFixed(2)
        } else if (promotion.type === 1) { // Promocja procentowa
          return (basePriceBrutto - (promotion.promotionValue / 100) * basePriceBrutto).toFixed(2)
        }
      }
      return this.getItemById(this.getCurrentItem(index).item).priceBrutto
    },
    getVatRate (index) {
      if (!this.getCurrentItem(index).item || this.items.length < 1) return 0
      return this.getItemById(this.getCurrentItem(index).item).vatRate.value
    },
    getVatValue (index) {
      if (!this.getCurrentItem(index).item) return 0
      return Math.round(this.calculateVatValue(index) * 100) / 100
    },
    calculateVatValue (index) {
      return (this.getPriceBrutto(index) * this.getVatRate(index)) / (100 + this.getVatRate(index))
    },
    getCurrentItem (index) {
      if (!this.variant.variantItems[index]) return null
      return this.variant.variantItems[index]
    },
    addNewItemPosition () {
      this.variant.variantItems.push({
        item: '',
        priceUserData: null,
        isCyclic: 0,
        alwaysSettleInFull: 0,
        dateFrom: this.data.dateFrom,
        dateTo: this.data.dateTo,
        timeless: Boolean(this.data.timelessAgreement),
        hasPromotion: false,
        promotion: null
      })
    },
    setTimelessAdditionalItem (index) {
      if (this.getCurrentAdditionalItem(index).timeless) this.getCurrentAdditionalItem(index).dateTo = null
    },
    hasAdditionalItemCustomPrices (index) {
      if (!this.priceOptions[index]) return false
      return this.priceOptions[index].length > 1
    },
    removeAdditionalPosition (index) {
      let currentAdditionalItem = this.variant.variantAdditionalItems[index]
      if (currentAdditionalItem && currentAdditionalItem['@id']) {
        remove(currentAdditionalItem['@id'], () => {
          this.variant.variantAdditionalItems.splice(index, 1)
        })
      } else {
        this.variant.variantAdditionalItems.splice(index, 1)
      }
    },
    getPriceNettoAdditional (index) {
      return Math.round((this.getPriceBruttoAdditional(index) - this.getVatValueAdditional(index)) * 100) / 100
    },
    getPriceBruttoAdditional (index) {
      if (!this.getCurrentAdditionalItem(index).item || this.items.length < 1) return 0
      let isCustomPriceSelected = (this.getCurrentAdditionalItem(index).priceUserData && typeof this.getCurrentAdditionalItem(index).priceUserData === 'string')
      if (isCustomPriceSelected) {
        return this.priceUserDataObjects.find(entry => {
          return entry.idItem['@id'] === this.getCurrentAdditionalItem(index).item
        }).priceBrutto
      }
      let promotionId = (this.getCurrentAdditionalItem(index).promotion)
      if (promotionId && this.getPromotions.length > 1) {
        let promotion = this.getPromotions.find(promotion => promotion.value === promotionId)
        let basePriceBrutto = this.getItemById(this.getCurrentAdditionalItem(index).item).priceBrutto
        if (promotion.type === 0) { // Promocja kwotowa
          return (basePriceBrutto - promotion.promotionValue).toFixed(2)
        } else if (promotion.type === 1) { // Promocja procentowa
          return (basePriceBrutto - (promotion.promotionValue / 100) * basePriceBrutto).toFixed(2)
        }
      }
      return this.getItemById(this.getCurrentAdditionalItem(index).item).priceBrutto
    },
    getVatRateAdditional (index) {
      if (!this.getCurrentAdditionalItem(index).item || this.items.length < 1) return 0
      return this.getItemById(this.getCurrentAdditionalItem(index).item).vatRate.value
    },
    getVatValueAdditional (index) {
      if (!this.getCurrentAdditionalItem(index).item) return 0
      return Math.round(this.calculateVatValueAdditional(index) * 100) / 100
    },
    calculateVatValueAdditional (index) {
      return (this.getPriceBruttoAdditional(index) * this.getVatRateAdditional(index)) / (100 + this.getVatRateAdditional(index))
    },
    getCurrentAdditionalItem (index) {
      if (!this.variant.variantAdditionalItems[index]) return null
      return this.variant.variantAdditionalItems[index]
    },
    addNewAdditionalItemPosition () {
      this.variant.variantAdditionalItems.push({
        item: '',
        priceUserData: null,
        isCyclic: 0,
        alwaysSettleInFull: 0,
        dateFrom: this.data.dateFrom,
        dateTo: this.data.dateTo,
        timeless: Boolean(this.data.timelessAgreement),
        hasPromotion: false,
        promotion: null
      })
    }
  }
}
</script>
